
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as _91id_930aof7xcgAn2Ux8x6anE5meLMXI_G2a9sk05aFmJaz_454Meta } from "/vercel/path0/pages/notes/[id].vue?macro=true";
import { default as _91id_93YicZcZSj1r5ZuGfYFOQuMrnuTW_bu1VUuctARYTRRT0Meta } from "/vercel/path0/pages/classes/[id].vue?macro=true";
import { default as indexCI6LAnrJJQGGqaSBrirBtDUuqDLoyFYI_45BxMId65GPYMeta } from "/vercel/path0/pages/classes/index.vue?macro=true";
import { default as _91id_935ehl07VDiQVt2NKhzvLaOWs49SVSpQ4Y94IUKRBhVG4Meta } from "/vercel/path0/pages/students/[id].vue?macro=true";
import { default as createNaQLVBt2Xm9rYVAWx1MNHa56CYYwPg1dWQ4sLrNC4iYMeta } from "/vercel/path0/pages/classes/create.vue?macro=true";
import { default as _91id_931FFuxvtIjJZJXSOJGxd1Gi_LDfskn6tJVntTHWezINEMeta } from "/vercel/path0/pages/classroom/[id].vue?macro=true";
import { default as indexUgSxJh2cQMyZBsE6m_450EFffw_kDnun59m7HC0AxonJ8Meta } from "/vercel/path0/pages/students/index.vue?macro=true";
import { default as create_a9ulcqsG1ZHJbfuGo2hB1TPFd0_452NjHd9Bznd2d0yEMeta } from "/vercel/path0/pages/students/create.vue?macro=true";
import { default as completedXicTHy_SGoAXE9kiwWRtxFiaXVkzfIBSM1KpQlMzM_wMeta } from "/vercel/path0/pages/classes/completed.vue?macro=true";
import { default as _91token_93fInYa59bnhNdb2aupX6NVTFM6pAWQ_45XWXk4qR5WdmRUMeta } from "/vercel/path0/pages/recording/[token].vue?macro=true";
import { default as _91id_93LSVzBggIuoMfP8y148UsvrB6GAl6XFCh72Qlc5KsaaIMeta } from "/vercel/path0/pages/lesson-report/[id].vue?macro=true";
import { default as indexZd9llybIgf1rsdBTBckqcL0ZsLYWstHxKFkmfbjHVPQMeta } from "/vercel/path0/pages/student/lessons/index.vue?macro=true";
import { default as completedY3RZYkwn19PSwtSS7i172pvEjcHLsrj3WGP_3ZoUcLEMeta } from "/vercel/path0/pages/student/lessons/completed.vue?macro=true";
import { default as StudentSessionRowGtJ0VPZ0y5zMIXo7EzgReERH9S0XgL_ZeZhWSDsvkdcMeta } from "/vercel/path0/pages/student/components/StudentSessionRow.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "notes-id",
    path: "/notes/:id()",
    meta: _91id_930aof7xcgAn2Ux8x6anE5meLMXI_G2a9sk05aFmJaz_454Meta || {},
    component: () => import("/vercel/path0/pages/notes/[id].vue")
  },
  {
    name: "classes-id",
    path: "/classes/:id()",
    meta: {"middleware":"auth:staff"},
    component: () => import("/vercel/path0/pages/classes/[id].vue")
  },
  {
    name: "classes",
    path: "/classes",
    meta: {"middleware":"auth:staff"},
    component: () => import("/vercel/path0/pages/classes/index.vue")
  },
  {
    name: "students-id",
    path: "/students/:id()",
    meta: {"middleware":"auth:staff"},
    component: () => import("/vercel/path0/pages/students/[id].vue")
  },
  {
    name: "classes-create",
    path: "/classes/create",
    meta: createNaQLVBt2Xm9rYVAWx1MNHa56CYYwPg1dWQ4sLrNC4iYMeta || {},
    component: () => import("/vercel/path0/pages/classes/create.vue")
  },
  {
    name: "classroom-id",
    path: "/classroom/:id()",
    meta: _91id_931FFuxvtIjJZJXSOJGxd1Gi_LDfskn6tJVntTHWezINEMeta || {},
    component: () => import("/vercel/path0/pages/classroom/[id].vue")
  },
  {
    name: "students",
    path: "/students",
    meta: {"middleware":"auth:staff"},
    component: () => import("/vercel/path0/pages/students/index.vue")
  },
  {
    name: "students-create",
    path: "/students/create",
    component: () => import("/vercel/path0/pages/students/create.vue")
  },
  {
    name: "classes-completed",
    path: "/classes/completed",
    meta: {"middleware":"auth:staff"},
    component: () => import("/vercel/path0/pages/classes/completed.vue")
  },
  {
    name: "recording-token",
    path: "/recording/:token()",
    meta: _91token_93fInYa59bnhNdb2aupX6NVTFM6pAWQ_45XWXk4qR5WdmRUMeta || {},
    component: () => import("/vercel/path0/pages/recording/[token].vue")
  },
  {
    name: "lesson-report-id",
    path: "/lesson-report/:id()",
    meta: {"middleware":"auth:staff"},
    component: () => import("/vercel/path0/pages/lesson-report/[id].vue")
  },
  {
    name: "student-lessons",
    path: "/student/lessons",
    meta: { ...(indexZd9llybIgf1rsdBTBckqcL0ZsLYWstHxKFkmfbjHVPQMeta || {}), ...{"middleware":"auth:student"} },
    component: () => import("/vercel/path0/pages/student/lessons/index.vue")
  },
  {
    name: "student-lessons-completed",
    path: "/student/lessons/completed",
    meta: { ...(completedY3RZYkwn19PSwtSS7i172pvEjcHLsrj3WGP_3ZoUcLEMeta || {}), ...{"middleware":"auth:student"} },
    component: () => import("/vercel/path0/pages/student/lessons/completed.vue")
  },
  {
    name: "student-components-StudentSessionRow",
    path: "/student/components/StudentSessionRow",
    component: () => import("/vercel/path0/pages/student/components/StudentSessionRow.vue")
  }
]